export const SALES_REPORTS_HUB_TITLE = 'Báo cáo bán hàng';

export const SALES_REPORT_DEFAULT_PAGE_SIZE = 50;
export const SALES_REPORT_MAX_PAGE_SIZE = 500;

export const BULK_IMEI_MAX = 1000;

export const OVERVIEW_SUBTITLE =
  'Chọn báo cáo bên dưới hoặc dùng thanh tab phía trên để điều hướng nhanh giữa 12 loại báo cáo.';

/** Thẻ điều hướng trên tab Tổng quan (Lovable) — `tabKey` khớp SALES_REPORT_TABS */
export const OVERVIEW_NAV_CARDS = [
  {
    tabKey: 'by-imei',
    title: 'Bán hàng theo IMEI',
    description: 'Mở rộng PMM: loại HĐ, DM cấp 1, SPC, NCC, dealsheet, giá net, lãi gộp.',
    icon: 'fas fa-mobile-alt',
    iconBg: 'violet',
  },
  {
    tabKey: 'purchase-by-imei',
    title: 'Mua hàng theo IMEI',
    description: 'Lịch sử nhập kho theo IMEI: NCC, phiếu nhập, dealsheet 1/2/3.',
    icon: 'fas fa-truck-loading',
    iconBg: 'orange',
  },
  {
    tabKey: 'bulk-check',
    title: 'Check IMEI hàng loạt',
    description: 'Dán tối đa 1.000 IMEI, tra vòng đời nhập → tồn → bán.',
    icon: 'fas fa-search',
    iconBg: 'indigo',
  },
  {
    tabKey: 'by-product',
    title: 'Theo sản phẩm',
    description: 'Doanh thu, giá vốn, lãi gộp, margin theo từng SKU.',
    icon: 'fas fa-cube',
    iconBg: 'blue',
  },
  {
    tabKey: 'by-bill',
    title: 'Theo đơn hàng',
    description: 'Liệt kê hóa đơn, lọc theo loại HĐ.',
    icon: 'fas fa-file-invoice-dollar',
    iconBg: 'indigo',
  },
  {
    tabKey: 'by-bill-type',
    title: 'Theo loại hoá đơn',
    description: 'Bán lẻ / buôn / giao hàng / trả hàng.',
    icon: 'fas fa-file-alt',
    iconBg: 'slate',
  },
  {
    tabKey: 'by-store-category',
    title: 'Theo cửa hàng',
    description: 'Doanh thu theo cửa hàng và cây danh mục cấp 1.',
    icon: 'fas fa-store',
    iconBg: 'teal',
  },
  {
    tabKey: 'purchases',
    title: 'Nhập hàng',
    description: 'Theo NCC, thương hiệu, danh mục, SP cha.',
    icon: 'fas fa-truck',
    iconBg: 'orange',
  },
  {
    tabKey: 'by-spc',
    title: 'Theo SPC',
    description: 'Gộp theo sản phẩm cha, doanh số / lãi TB.',
    icon: 'fas fa-layer-group',
    iconBg: 'cyan',
  },
  {
    tabKey: 'by-customer',
    title: 'Theo khách hàng',
    description: 'Doanh thu theo nhóm khách: lẻ, sỉ, công ty…',
    icon: 'fas fa-users',
    iconBg: 'green',
  },
  {
    tabKey: 'by-customer-product',
    title: 'KH × Hàng hóa',
    description: 'Cross-tab khách × SP, margin chi tiết.',
    icon: 'fas fa-user-tag',
    iconBg: 'pink',
  },
  {
    tabKey: 'inventory-value-by-store',
    title: 'Giá trị tồn kho',
    description: 'Snapshot tồn × giá nhập gốc theo kho.',
    icon: 'fas fa-warehouse',
    iconBg: 'amber',
  },
];

export const SALES_REPORT_TABS = [
  {
    key: 'overview',
    label: 'Tổng quan',
    legacyPermissions: [],
    paginated: false,
    title: 'Tổng quan báo cáo bán hàng',
    apiPath: '/sales-reports/overview',
    hideDateFilter: false,
    chartType: null,
    layout: 'overview',
  },
  {
    key: 'by-imei',
    label: 'Bán theo IMEI',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo bán hàng theo IMEI',
    apiPath: '/sales-reports/by-imei',
    chartType: null,
    tableTitle: 'Chi tiết IMEI',
    searchPlaceholder: 'iphone 15 pro · tách từ khóa bằng dấu cách',
    periodSuffix: 'IMEI',
    filterMode: 'advanced',
    multiSelectAdvanced: true,
    filterFields: ['date', 'store', 'smartSearch'],
    advancedFields: ['billType', 'brand', 'category', 'provider', 'subProvider', 'spc', 'customer'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'loaiHoaDon', label: 'Loại HĐ', type: 'bill-type' },
      { key: 'tenHang', label: 'Sản phẩm', type: 'product' },
      { key: 'imei', label: 'IMEI', type: 'text' },
      { key: 'tenKhach', label: 'Khách hàng', type: 'text' },
      { key: 'ngayMuaBan', label: 'Ngày mua → bán', type: 'date-range-stacked' },
      { key: 'tuoiTon', label: 'Tuổi tồn', type: 'age' },
      // { key: 'giaBan', label: 'Giá bán (trước VAT)', type: 'currency-bold' },
      { key: 'giaBanSauVAT', label: 'Giá bán (sau VAT)', type: 'currency-bold' },
      { key: 'giaVon', label: 'Giá vốn (sau VAT)', type: 'currency-muted' },
      { key: 'giaNet', label: 'Giá net', type: 'currency-muted' },
      { key: 'laiGop', label: 'Lãi gộp', type: 'currency-success' },
      { key: 'maPhieuXuat', label: 'Phiếu xuất', type: 'link' },
      { key: 'khoBan', label: 'Kho bán', type: 'text' },
      { key: 'nccMaPhu', label: 'NCC / Mã phụ', type: 'ncc-multi' },
      { key: 'phieuNhap', label: 'Phiếu nhập', type: 'text' },
      { key: 'spcDmBrand', label: 'SPC / DM / Brand', type: 'spc-multi' },
      { key: 'nhanVien', label: 'NV bán', type: 'text' },
    ],
  },
  {
    key: 'purchase-by-imei',
    label: 'Mua theo IMEI',
    legacyPermissions: [],
    paginated: true,
    title: 'Mua hàng theo IMEI',
    apiPath: '/purchase-reports/by-imei',
    endpoint: 'purchase-reports/by-imei',
    summaryEndpoint: 'purchase-reports/by-imei/summary',
    apiPrefix: '/v1',
    chartType: null,
    tableTitle: 'Chi tiết nhập IMEI',
    searchPlaceholder: 'iphone 15 pro · tách từ khóa bằng dấu cách',
    periodSuffix: 'IMEI',
    filterMode: 'advanced',
    multiSelectAdvanced: true,
    filterFields: ['date', 'store', 'smartSearch'],
    advancedFields: ['category', 'provider', 'subProvider'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'ngayNhap', label: 'Ngày nhập', type: 'date-db' },
      { key: 'imei', label: 'IMEI', type: 'text' },
      { key: 'khachHang', label: 'Nhà cung cấp', type: 'text' },
      { key: 'tenHang', label: 'Sản phẩm', type: 'product' },
      { key: 'soLuong', label: 'SL', type: 'number' },
      { key: 'gia', label: 'Giá', type: 'currency-bold' },
      { key: 'soHoaDon', label: 'Số HĐ', type: 'text' },
      { key: 'ngayHoaDon', label: 'Ngày HĐ', type: 'date-db' },
      { key: 'soPhieu', label: 'Số phiếu', type: 'text' },
      { key: 'kho', label: 'Kho', type: 'text' },
      { key: 'dienGiai', label: 'Diễn giải', type: 'text' },
      { key: 'maNccPhu', label: 'Mã NCC phụ', type: 'text' },
      { key: 'dealsheets', label: 'DS1/2/3', type: 'ds-stack' },
    ],
  },
  {
    key: 'bulk-check',
    label: 'Check IMEI hàng loạt',
    legacyPermissions: [],
    paginated: false,
    title: 'Check IMEI hàng loạt',
    apiPath: '/imei-reports/bulk-check',
    apiMethod: 'POST',
    layout: 'bulk-imei',
    hideDateFilter: true,
    showExport: false,
    chartType: null,
  },
  {
    key: 'by-product',
    label: 'Theo SP',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo theo sản phẩm',
    apiPath: '/sales-reports/by-product',
    chartType: 'bar-horizontal',
    chartTitle: 'Top SP theo doanh thu',
    searchPlaceholder: 'iphone 15 pro · tách từ khóa bằng dấu cách',
    periodSuffix: 'SKU',
    filterMode: 'advanced',
    filterFields: ['date', 'store', 'smartSearch'],
    advancedFields: ['brand', 'category'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'tenHang', label: 'Sản phẩm', type: 'product' },
      { key: 'soLuong', label: 'SL', type: 'number' },
      { key: 'doanhThu', label: 'Doanh thu', type: 'currency-bold' },
      { key: 'giaVon', label: 'Giá vốn', type: 'currency-muted' },
      { key: 'laiGop', label: 'Lãi gộp', type: 'currency-success' },
      { key: 'margin', label: 'Margin', type: 'margin-badge' },
    ],
  },
  {
    key: 'by-bill',
    label: 'Theo đơn hàng',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo theo đơn hàng',
    apiPath: '/sales-reports/by-bill',
    chartType: 'line',
    chartTitle: 'Doanh thu theo ngày',
    tableTitle: 'Danh sách hoá đơn',
    searchPlaceholder: 'Số HĐ / Số seri / Tên khách...',
    periodSuffix: 'hoá đơn',
    filterFields: ['date', 'store', 'search', 'billType'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'ngayHoaDon', label: 'Ngày HĐ', type: 'date-db' },
      { key: 'soHoaDon', label: 'Số HĐ', type: 'link' },
      { key: 'soSeri', label: 'Số seri', type: 'text' },
      { key: 'tenKhach', label: 'Khách hàng', type: 'text' },
      { key: 'soLuong', label: 'SL', type: 'number' },
      { key: 'doanhThu', label: 'Doanh thu', type: 'currency-bold' },
      { key: 'giaVon', label: 'Giá vốn', type: 'currency-muted' },
      { key: 'giamGia', label: 'Giảm giá', type: 'currency-danger' },
      { key: 'laiGop', label: 'Lãi gộp', type: 'currency-success' },
    ],
  },
  {
    key: 'by-bill-type',
    label: 'Theo loại HĐ',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo theo loại hoá đơn',
    apiPath: '/sales-reports/by-bill-type',
    chartType: 'donut',
    chartTitle: 'Tỉ trọng doanh thu',
    layout: 'split',
    periodSuffix: null,
    filterFields: ['date', 'store'],
    columns: [
      { key: 'loaiHoaDon', label: 'Loại HĐ', type: 'bill-type' },
      { key: 'slDon', label: 'Đơn', type: 'number' },
      { key: 'slHangHoa', label: 'SL HH', type: 'number' },
      { key: 'doanhThu', label: 'Doanh thu', type: 'currency-bold' },
      { key: 'giaVon', label: 'Giá vốn', type: 'currency-muted' },
    ],
  },
  {
    key: 'by-store-category',
    label: 'Theo CH',
    legacyPermissions: [],
    paginated: false,
    title: 'Báo cáo theo cửa hàng (danh mục cấp 1)',
    apiPath: '/sales-reports/by-store-category',
    chartType: 'bar-horizontal',
    chartTitle: 'Doanh thu theo danh mục (cấp 1)',
    tableTitle: 'Chi tiết theo cửa hàng',
    periodSuffix: 'dòng',
    filterMode: 'advanced',
    filterFields: ['date', 'store'],
    advancedFields: ['brand', 'category'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'maCuaHang', label: 'Mã CH', type: 'text' },
      { key: 'tenCuaHang', label: 'Cửa hàng', type: 'store' },
      { key: 'cayDanhMuc', label: 'Cây danh mục', type: 'text' },
      { key: 'slDon', label: 'Đơn', type: 'number' },
      { key: 'slHangHoa', label: 'SL HH', type: 'number' },
      { key: 'doanhThu', label: 'Doanh thu', type: 'currency-bold' },
      { key: 'giaVon', label: 'Giá vốn', type: 'currency-muted' },
      { key: 'giamGia', label: 'Giảm giá', type: 'currency-danger' },
      { key: 'laiGop', label: 'Lãi gộp', type: 'currency-success' },
    ],
  },
  {
    key: 'purchases',
    label: 'Nhập hàng',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo nhập hàng',
    apiPath: '/sales-reports/purchases',
    chartType: 'bar-horizontal',
    chartTitle: 'Top NCC theo giá trị nhập',
    chartColor: '#f97316',
    periodSuffix: 'dòng',
    filterMode: 'advanced',
    filterFields: ['date', 'store'],
    advancedFields: ['brand', 'provider'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'nhaCungCap', label: 'Nhà cung cấp', type: 'text' },
      { key: 'thuongHieu', label: 'Thương hiệu', type: 'text' },
      { key: 'cayDanhMuc', label: 'Cây danh mục', type: 'text' },
      { key: 'sanPhamCha', label: 'Sản phẩm cha', type: 'text' },
      { key: 'soLuong', label: 'Số lượng', type: 'number' },
      { key: 'thanhTienSauVat', label: 'Thành tiền sau VAT', type: 'currency-bold' },
    ],
  },
  {
    key: 'by-spc',
    label: 'Theo SPC',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo theo SPC (sản phẩm cha)',
    apiPath: '/sales-reports/by-spc',
    chartType: 'bar-dual',
    chartTitle: 'Top SPC theo doanh số',
    searchPlaceholder: 'iphone 15 pro · SPC / mã hàng / barcode',
    periodSuffix: 'SPC',
    filterMode: 'advanced',
    filterFields: ['date', 'store', 'smartSearch'],
    advancedFields: ['brand', 'category'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'thuongHieu', label: 'Thương hiệu', type: 'text' },
      { key: 'danhMucCap1', label: 'DM cấp 1', type: 'text' },
      { key: 'spc', label: 'SPC', type: 'text' },
      { key: 'soLuong', label: 'SL', type: 'number' },
      { key: 'tongDoanhSo', label: 'Tổng doanh số', type: 'currency-bold' },
      { key: 'doanhSoTb', label: 'Doanh số TB', type: 'currency-muted' },
      { key: 'tongGiaVon', label: 'Tổng giá vốn', type: 'currency-muted' },
      { key: 'tongLai', label: 'Tổng lãi', type: 'currency-success' },
      { key: 'laiTb', label: 'Lãi TB', type: 'currency-success' },
    ],
  },
  {
    key: 'by-customer',
    label: 'Theo KH',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo theo khách hàng',
    apiPath: '/sales-reports/by-customer',
    chartType: 'donut',
    chartTitle: 'Doanh thu theo nhóm khách',
    layout: 'split',
    searchPlaceholder: 'Tên khách / Mã khách / Nhóm...',
    periodSuffix: 'khách',
    filterFields: ['date', 'store', 'search'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'nhomKhach', label: 'Nhóm', type: 'text' },
      { key: 'maKhach', label: 'Mã khách', type: 'link' },
      { key: 'tenKhach', label: 'Tên khách', type: 'text' },
      { key: 'soLuong', label: 'SL', type: 'number' },
      { key: 'doanhThu', label: 'Doanh thu', type: 'currency-bold' },
    ],
  },
  {
    key: 'by-customer-product',
    label: 'KH × hàng hóa',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo khách hàng × hàng hóa',
    apiPath: '/sales-reports/by-customer-product',
    chartType: null,
    periodSuffix: 'dòng',
    filterMode: 'advanced',
    filterFields: ['date', 'store'],
    advancedFields: ['brand', 'category'],
    columns: [
      { key: 'stt', label: 'STT', type: 'index' },
      { key: 'tenKhach', label: 'Khách hàng', type: 'customer' },
      { key: 'nhomKhach', label: 'Nhóm', type: 'text' },
      { key: 'tenHang', label: 'Sản phẩm', type: 'product' },
      { key: 'soLuong', label: 'SL', type: 'number' },
      { key: 'doanhThu', label: 'Doanh thu', type: 'currency-bold' },
      { key: 'giaVon', label: 'Giá vốn', type: 'currency-muted' },
      { key: 'laiGop', label: 'Lãi gộp', type: 'currency-success' },
      { key: 'margin', label: 'Margin', type: 'margin-badge' },
    ],
  },
  {
    key: 'inventory-value-by-store',
    label: 'Giá trị tồn kho',
    legacyPermissions: [],
    paginated: true,
    title: 'Báo cáo giá trị tồn kho theo kho',
    apiPath: '/sales-reports/inventory-value-by-store',
    chartType: 'bar-horizontal',
    chartTitle: 'Giá trị tồn kho theo kho',
    chartColor: '#f97316',
    hideDateFilter: true,
    snapshotSubtitle: true,
    searchPlaceholder: 'Mã kho / Tên kho...',
    periodSuffix: 'kho',
    filterFields: ['store', 'search'],
    columns: [
      { key: 'maKho', label: 'Mã kho', type: 'link' },
      { key: 'tenKho', label: 'Tên kho', type: 'text' },
      { key: 'slHangHoa', label: 'SL hàng hoá', type: 'number' },
      { key: 'tongGiaTriTonKho', label: 'Tổng giá trị tồn kho', type: 'currency-bold' },
      { key: 'tiTrong', label: 'Tỉ trọng', type: 'share-bar' },
    ],
  },
];

export const BILL_TYPE_OPTIONS = [
  { value: null, text: 'Tất cả loại HĐ' },
  { value: 1, text: 'Hóa đơn bán lẻ' },
  { value: 2, text: 'Hóa đơn bán buôn' },
  { value: 4, text: 'Hóa đơn giao hàng' },
  { value: 3, text: 'Hóa đơn trả hàng' },
];

export const BILL_TYPE_META = {
  1: { label: 'Hóa đơn bán lẻ', color: '#3b82f6' },
  2: { label: 'Hóa đơn bán buôn', color: '#22c55e' },
  4: { label: 'Hóa đơn giao hàng', color: '#f97316' },
  3: { label: 'Hóa đơn trả hàng', color: '#dc2626', isReturn: true },
};

export const getTabByKey = (key) => SALES_REPORT_TABS.find((tab) => tab.key === key);
